// Login/Signup Modal Component
//
// The dialog shell only: the form itself lives in <AuthForm>, which the
// standalone /signup page mounts as well, so both stay identical.
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import AuthForm from './AuthForm';
import './LoginModal.css';

const LoginModal = ({ show, onHide, initialMode = 'login' }) => {
  // Mode: 'login' or 'signup'. Reset whenever the modal opens so a "keep this
  // workspace" click lands on Create Account rather than leftover Sign In.
  const [mode, setMode] = useState(initialMode);
  useEffect(() => {
    if (show) setMode(initialMode);
  }, [show, initialMode]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="login-modal">
      <Modal.Header closeButton>
        <Modal.Title>{mode === 'login' ? 'Sign In' : 'Create Account'}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <AuthForm mode={mode} onModeChange={setMode} onSuccess={onHide} />
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
